"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var form_export_dialog_component_1 = require("./form-export-dialog.component");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Subject_1 = require("rxjs/Subject");
var FormDocumentationComponent = /** @class */ (function () {
    function FormDocumentationComponent(dialog, eventBase) {
        this.dialog = dialog;
        this.eventBase = eventBase;
        this.destroy$ = new Subject_1.Subject();
    }
    FormDocumentationComponent.prototype.ngOnInit = function () {
        this.initListener();
    };
    FormDocumentationComponent.prototype.openFormExportDialog = function () {
        this.dialog.open(form_export_dialog_component_1.FormExportDialogComponent, form_export_dialog_component_1.FormExportDialogComponent.getConfig())
            .afterClosed()
            .take(1)
            .subscribe();
    };
    FormDocumentationComponent.prototype.initListener = function () {
        var _this = this;
        this.eventBase.listen('form-documentation').takeUntil(this.destroy$).subscribe(function () {
            _this.openFormExportDialog();
        });
    };
    FormDocumentationComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    FormDocumentationComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-form-documentation',
            template: ''
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            idm_session_data_provider_api_js_1.EventBase])
    ], FormDocumentationComponent);
    return FormDocumentationComponent;
}());
exports.FormDocumentationComponent = FormDocumentationComponent;
//# sourceMappingURL=form-documentation.component.js.map